import React, { useState } from 'react';

import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Alert, Input } from 'antd';

import StepGuide from 'components/StepGuide';

import FaqLink from '../../Basic/FaqLink';

interface IProps {
  handleDomain: (domain: string) => void;
  validated: boolean;
  hasDomain: boolean;
  domain: string;
  loading: boolean;
}

function DomainForm({ hasDomain, validated, handleDomain, domain, loading }: IProps) {
  const faqUrl = 'https://ajuda.eduzz.com/?article=como-configurar-o-pixel-orbita';
  const message = validated
    ? 'Configurações ativas e disponíveis para uso, aproveite!'
    : 'A verificação ainda não foi realizada, aguarde um pouco mais.';

  const [handleDomainConfig, setHandleDomainConfig] = useState(false);

  return (
    <>
      <button
        className='text-primary! cursor-pointer! border-none! bg-transparent! p-0! text-base! font-medium!'
        onClick={() => setHandleDomainConfig(!handleDomainConfig)}
      >
        {'Configurações de domínio  '}
        {handleDomainConfig ? (
          <UpOutlined style={{ fontSize: 'inherit' }} />
        ) : (
          <DownOutlined style={{ fontSize: 'inherit' }} />
        )}
      </button>

      {handleDomainConfig && (
        <>
          <div className='mt-2' />
          <p className='text-text-secondary mb-0! text-[15px] font-normal'>
            Para configurar seu domínio, siga os passos abaixo. Algumas das etapas são feitas fora da plataforma Eduzz.
          </p>
          <div className='mt-4' />
          <p className='text-text-secondary mb-0! text-[15px] font-normal'>
            1 - Configure o dominio no Gerenciador de Negócios do Facebook{' '}
            <a target='_blank' rel='noopener noreferrer' href='https://business.facebook.com/'>
              clicando aqui.&nbsp;
            </a>
            <br />
            Acesse <b>Configurações de Negócio &gt; Segurança da marca &gt; Domínios.</b>
          </p>
          <div className='mt-2' />
          <p className='text-text-secondary mb-0! text-[15px] font-normal'>
            2 - Registre seu CNAME seguindo os passos abaixo.
          </p>
          <div className='mt-2' />
          <StepGuide>
            No provedor do seu domínio vá em configurações de <span>DNS</span>
          </StepGuide>
          <StepGuide>
            Configure seu CNAME, apontando para <span>pixel.eduzz.com</span>
          </StepGuide>
          <StepGuide>Salve as configurações</StepGuide>
          <div className='mt-2' />
          <p className='text-text-secondary mb-0! text-[15px] font-normal'>3 - Copie e cole aqui seu CNAME.</p>
          <Input
            disabled={loading}
            className='w-full'
            value={domain}
            onChange={(e: any) => handleDomain(e.target.value)}
          />
          <span className='text-xs text-gray-500'>Ex: pixel.seudominio.com</span>
          <div className='mt-2' />
          <p className='text-text-secondary mb-0! text-[15px] font-normal'>
            4 - A Validação será automática e assim que feita estará disponível para uso. Esse processo pode demorar até
            72 horas.
          </p>
          <div className='mt-2' />

          {hasDomain && (
            <>
              <Alert type={validated ? 'info' : 'warning'} message={message} />
              <div className='mt-2' />
            </>
          )}
          <div className='flex w-full justify-center'>
            <FaqLink link={faqUrl} />
          </div>
          <div className='mt-4' />
        </>
      )}
    </>
  );
}

export default React.memo(DomainForm);
